import { Component, inject, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import { MatDivider } from '@angular/material/list';
import { MatFormField, MatLabel, MatOption, MatSelect } from '@angular/material/select';
import { EnpsComponent } from '@src/suite/common/components/base/enps-component';
import { PublicationChannelSchedule, PublicationChannelType } from '@src/suite/common/data-models/records/publication-channel-record';
import { ObjectTypes } from '@src/suite/common/enums/object-types';
import { LanguageSettings } from '@src/suite/common/services/language-settings';
import { PublicationChannelsService } from '@src/suite/common/services/publication-channels-service';
import { initializeRecord } from '@src/suite/common/utils/record-utils';

import { LoaderComponent } from '../../../../loader/loader';

@Component({
    selector: 'st-add-publication-channel',
    imports: [FormsModule, LoaderComponent, MatButton, MatButtonToggleGroup, MatDivider, MatFormField, MatInput, MatLabel, MatOption, MatSelect, ReactiveFormsModule],
    templateUrl: './add-publication-channel.html',
    styleUrl: './add-publication-channel.scss',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-add-publication-channel',
    },
})
export class AddPublicationChannelComponent extends EnpsComponent {
    publicationChannelsService = inject(PublicationChannelsService);
    languageSettings = inject(LanguageSettings);
    dialogRef = inject<MatDialogRef<AddPublicationChannelComponent>>(MatDialogRef);
    inputData = inject(MAT_DIALOG_DATA);

    public newChannel: StorytellingPublicationChannelRecord = initializeRecord<StorytellingPublicationChannelRecord>(ObjectTypes.PUBLICATION_CHANNEL);
    public loading = false;
    private noWhiteSpaceValidator = Validators.pattern(/^((?!\s{2,}).)*$/);

    public publicationChannelGroup = new FormGroup({
        channelName: new FormControl(null, [Validators.required, this.noWhiteSpaceValidator]),
        channelAction: new FormControl(null, Validators.required),
        channelType: new FormControl<PublicationChannelType>(null, Validators.required),
        channelSchedule: new FormControl<PublicationChannelSchedule>(null, Validators.required),
        channelSections: new FormControl(null, [Validators.required, this.noWhiteSpaceValidator]),
        channelRevisions: new FormControl(null, Validators.required),
        channelEditionNames: new FormControl(null),
    });

    cancelNew() {
        this.dialogRef.close();
    }

    updateTextField(event: string, field: string) {
        this.newChannel[field] = event;
    }

    async addChannel() {
        this.newChannel.Title = this.publicationChannelGroup.controls.channelName.value;
        this.newChannel.PSTPublicationChannelActionID = this.publicationChannelGroup.controls.channelAction.value;
        this.newChannel.PSTPublicationChannelType = this.publicationChannelGroup.controls.channelType.value;
        this.newChannel.PSTPublicationChannelSchedule = this.publicationChannelGroup.controls.channelSchedule.value;
        this.newChannel.PSTPublicationChannelSections = this.publicationChannelGroup.controls.channelSections.value;
        this.newChannel.PSTPublicationChannelRevisions = this.publicationChannelGroup.controls.channelRevisions.value;
        this.newChannel.PSTPublicationChannelEditionNames = this.publicationChannelGroup.controls.channelEditionNames.value;
        if (this.publicationChannelGroup.valid) {
            this.loading = true;
            try {
                const res = await this.publicationChannelsService.createPublicationChannelRecord(this.newChannel);
                if (res.status) {
                    this.dialogRef.close(true);
                }
            } catch (error) {
                console.warn(error);
            } finally {
                this.loading = false;
            }
        }
    }
}
